import { SUPPORT_EMAIL } from "@/constants/legal";
import type { CompanyLegalInfo } from "@/types/legal";

interface ContactBlockProps {
  company: CompanyLegalInfo;
}

export const ContactBlock = ({ company }: ContactBlockProps) => {
  return (
    <address className="rounded-2xl border border-border bg-card p-5 not-italic">
      <p className="font-semibold text-foreground">{company.companyName}</p>
      <p className="text-muted-foreground">{company.registrationNumber}</p>
      <p className="text-muted-foreground">{company.address}</p>
      <p className="mt-2 text-muted-foreground">
        Email:{" "}
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="font-medium text-foreground hover:text-muted-foreground"
        >
          {SUPPORT_EMAIL}
        </a>
      </p>
      <p className="text-muted-foreground">
        Website:{" "}
        <a
          href="https://dualio.ai"
          className="font-medium text-foreground hover:text-muted-foreground"
        >
          https://dualio.ai
        </a>
      </p>
    </address>
  );
};
